export default function toggleDirective(MapService) {
	"ngInject";

	return {
		restrict: "E",
		replace: true,
		transclude: true,
		templateUrl: "./components/toggle/toggle-template.html",
		scope: {
			active: "=?",
			defaultActive: "<?",
			heading: "@?",
			color: "<?",
			type: "@?",
			icon: "@?",
			onIconClick: "&?"
		},
		bindToController: true,
		controllerAs: "vm",
		controller: function () {
			"ngInject";

			const vm = this;

			vm.$onInit = () => {
				if (angular.isUndefined(vm.active)) {
					vm.active = angular.isUndefined(vm.defaultActive) ? true : vm.defaultActive;
				}
				if (vm.type && angular.isUndefined(vm.color)) {
					vm.color = MapService.getColor(vm.type);
				}
				if (vm.type && angular.isUndefined(vm.iconUrl)) {
					vm.iconUrl = MapService.getIconUrl(vm.type);
				}
			};
		}
	};
}
